var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"group":"notifications","position":"top right","classes":"vue-notification-template vue-notification "}})
}
var staticRenderFns = []

export { render, staticRenderFns }